import ThirdPartyCompanyEditor from '_legacy/modules/shared/columns/editors/ThirdPartyCompanyEditor';
import { CompanyWeightingType } from 'common/types/companyWeightingType';

class ThirdPartyBuyerEditor extends ThirdPartyCompanyEditor {
    render() {
        return super.render(null, CompanyWeightingType.Buyer);
    }
}

export default ThirdPartyBuyerEditor;
